import React from "react";
import "./Header.css";
import { useState } from "react";

function Header() {
  const[activenav,setActiveNav] = useState('#');
  return (
    <div>
      <div className="nav-parent">
        <a href="#" onClick={()=>setActiveNav('#')} className={activenav === "#" ? 'active':''}>
          <i className="fa fa-home" />
        </a>
        <a href="#about"  onClick={()=>setActiveNav('#about')}>
          <i className="fa fa-user" />
        </a>
        <a href="#contact" onClick={()=>setActiveNav('#contact')}>
          <i className="fa fa-phone" />
        </a>
        <a href="#skill" onClick={()=>setActiveNav('#skill')}>
          <i className="fa fa-tasks" />
        </a>
        <a href="https://www.facebook.com/atyantchauhan007/" onClick={()=>setActiveNav('#skill')} target="_blank" >
          <i className="fa fa-facebook" />
        </a>
        <a href="https://www.linkedin.com/in/atyant-kumar-682945222" onClick={()=>setActiveNav('#skill')} target="_blank" >
          <i className="fa fa-linkedin" />
        </a>
        <a href="https://www.instagram.com/chauhan_atyant/" target="_blank" onClick={()=>setActiveNav('#skill')} >
          <i className="fa fa-instagram" />
        </a>
        
      </div>
        
    </div>
  );
}

export default Header;
